import { Card } from "azure-devops-ui/Card";
import { ObservableValue } from "azure-devops-ui/Core/Observable";
import * as React from "react";

const stats = [
    {
        label: "Points",
        value: 340
    },
    {
        label: "3PM",
        value: 23
    },
    {
        label: "Rebounds",
        value: 203
    },
    {
        label: "Assists",
        value: 290
    },
    {
        label: "Steals",
        value: 56
    }
];

export default class CollapsibleCardExample extends React.Component {
    private collapsed = new ObservableValue<boolean>(false);
    public render(): JSX.Element {
        return (
            <Card
                className="flex-grow"
                collapsible={true}
                collapsed={this.collapsed}
                onCollapseClick={this.onCollapseClicked}
                titleProps={{ text: "Will Orta 2018-2019 🏀" }}
            >
                <div className="flex-row" style={{ flexWrap: "wrap" }}>
                    {stats.map((items, index) => (
                        <div className="flex-column" style={{ minWidth: "120px" }} key={index}>
                            <div className="body-m secondary-text">{items.label}</div>
                            <div className="body-m primary-text">{items.value}</div>
                        </div>
                    ))}
                </div>
            </Card>
        );
    }

    private onCollapseClicked = () => {
        this.collapsed.value = !this.collapsed.value;
    };
}
